// extracted by mini-css-extract-plugin
export default {"wallet":"WalletInfo_wallet__0OXml","wallet__name":"WalletInfo_wallet__name__UtR1h","wallet__account":"WalletInfo_wallet__account__Nou8a"};